/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Share_Sendemail2Inputs */

const en_coinvestments_share_sendemail2 = /** @type {(inputs: Coinvestments_Share_Sendemail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send Email`)
};

/**
* | output |
* | --- |
* | "Send Email" |
*
* @param {Coinvestments_Share_Sendemail2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_share_sendemail2 = /** @type {((inputs?: Coinvestments_Share_Sendemail2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Share_Sendemail2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_share_sendemail2(inputs)
});
export { coinvestments_share_sendemail2 as "coInvestments_share_sendEmail" }